import { AnswerChoice, Answer } from './types';

export const createAnswer = (answerChoices: AnswerChoice[]): Answer => ({
  choice: answerChoices,
});
